export default {
  mounted() {
      
      this.$route.params.lang ? this.lang = this.$route.params.lang : this.lang = this.checkLanguage() || sessionStorage.getItem('lan')
      // eventBus.$on('updateLanguage', this.setLang)

      window.onresize = () => {
        this.viewPortWidth = window.innerWidth
        // console.log('inside mixin - viewPortWidth', this.viewPortWidth)
      }
    },
    computed: {
      language() {
        if (this.lang) {
          return this.lang
        } else {
          this.checkLanguage()
        }
        return this.lang
      }
    },
  methods: {
    checkLanguage() {
      if (window.location.href.indexOf('krishna-said') > -1) {
        this.lang = 'en'
        sessionStorage.setItem('lan', 'en')
      } else {
        this.lang = 'pt'
        sessionStorage.setItem('lan', 'pt')
      }
    },
    setLang(l) {
      this.lang = l
    },
  },
}